import {
  postCall,
  QueryParamsInterface,
  HeadersInterface,
  BodyParamsInterface,
} from "./api";

const BASE_URL = "v1/payments";

export const processPaymentCall = async (
  paymentMethod: string,
  isMonthly: boolean
) => {
  let url = BASE_URL + "/process";

  let body: BodyParamsInterface = [
    { name: "payment_method", value: paymentMethod },
    { name: "is_monthly", value: isMonthly },
  ];
  let headers: HeadersInterface | undefined;

  let response = await postCall(url, headers, undefined, body);

  return response.status;
};
